import AuditHeader from "@/components/audits/AuditHeader";
import FailedInteractionMessage from "@/components/audits/FailedInteractionMessage";
import InteractionReplay from "@/components/audits/InteractionReplay";
import UsabilityEvaluationSection from "@/components/audits/UsabilityEvaluationSection";
import Layout from "@/components/Layout";
import { useLiveReload } from "@/hooks/useLiveReload";
import type { Audit } from "@/types";

type ShowProps = {
  audit: Audit;
};

export default function Show({ audit }: ShowProps) {
  const pageTitle = audit.scenario.objective || "Audit";
  const usabilityEvaluationRunning =
    audit.usability_evaluation.status === "pending" || audit.usability_evaluation.status === "running";
  const live = audit.running || audit.cancellable || usabilityEvaluationRunning;

  useLiveReload({
    channel: "AuditChannel",
    id: audit.id,
    only: ["audit"],
    enabled: live,
  });

  return (
    <Layout title={pageTitle}>
      <AuditHeader audit={audit} />
      <FailedInteractionMessage audit={audit} />
      <UsabilityEvaluationSection evaluation={audit.usability_evaluation} interactions={audit.interactions} />
      <InteractionReplay audit={audit} />
    </Layout>
  );
}
